import ru from './ru'
import Utils from '../Utils'

var ruMsg = {
  'agreements.title': 'Соглашения',
  'agreements.error.mandatory': "Для продолжения пользования сервисами Deeper требуется ваше согласие",
  'agreements.error.blank': "Выберите пункт",
  'agreements.back': 'Назад',
  'agreements.agree': 'Согласие',
  'agreements.decline': 'Отклонить',
  'agreements.text.full': 'Все соглашение'
}

Utils.addTerms(ruMsg, ru)

export default ruMsg



// WEBPACK FOOTER //
// ./src/lang/ruMsg.js